app.controller("RemindersIndexController", [
    "$scope", "$stateParams", "Students", "$uibModal", "$state", "RemindersService", "usSpinnerService", "ConfirmModal", "toastr",
    function ($scope, $stateParams, Students, $uibModal, $state, RemindersService, usSpinnerService, ConfirmModal, toastr) {
        $scope.reminders = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 10;

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.open = function(reminder){
            $state.go(reminder.route, reminder.routeParams);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
            };
            usSpinnerService.spin("root");
            RemindersService.list({
                page: page,
                limit: $scope.itemsPerPage
            }).then(function (data) {
                $scope.reminders = data.docs;
                $scope.totalItems = data.total;
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query
            });
        };

        $scope.createReminder = function () {
            $uibModal.open({
                controller: "RemindersCreateModalController",
                templateUrl: _pb + 'admin/reminders/create.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            type: 'create-notification',
                            text: '',
                            editableText: true,
                            route: 'admin.createNotifications',
                            routeParams: {}
                        }
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($stateParams.page);
                });
        };

        $scope.deleteReminder = function (reminder, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            ConfirmModal.show({
                title: "შემხსენებლის წაშლა",
                message: "ნამდვილად გსურთ ამ ოპერაციის შესრულება?"
            }).result.then(function () {
                RemindersService.delete(reminder._id)
                    .then(function () {
                        toastr.success('', 'შემხსენებელი წარმატებით წაიშალა');
                        loadPage($stateParams.page);
                    });
            });
        };
    }
]);
